import { FieldMode, SnPartyConfigDTO, SnTagSetting, TagEnum, TagCondition } from '@api/ringil-api.v2';
import { CUSTOMIZATION_MODE_DISABLED, CUSTOMIZATION_MODE_OPTIONAL, CUSTOMIZATION_MODE_READONLY, CUSTOMIZATION_MODE_REQUIRED } from '@utils/exports';

// The generated client types `shippingTags` as `any` (map serialization); narrow it here.
export type ShippingTags = Partial<Record<TagEnum, SnTagSetting>>;

// FieldMode triple -> legacy CUSTOMIZATION_MODE_* string, for the obsolete OrderComponent boundary.
// FFF=DISABLED, TFF=READONLY, TTF=READWRITE(=OPTIONAL), TTT=REQUIRED.
export const fieldModeToCustomizationMode = (fm?: FieldMode): string => {
  if (!fm?.visible) return CUSTOMIZATION_MODE_DISABLED;
  if (!fm.editable) return CUSTOMIZATION_MODE_READONLY;
  return fm.required ? CUSTOMIZATION_MODE_REQUIRED : CUSTOMIZATION_MODE_OPTIONAL;
};

export const getTag = (config: SnPartyConfigDTO | undefined, key: TagEnum): SnTagSetting | undefined =>
  (config?.shippingTags as ShippingTags | undefined)?.[key];

export interface SnTagConfig {
  isVisible: (key: TagEnum) => boolean;
  isEditable: (key: TagEnum) => boolean;
  isRequired: (key: TagEnum) => boolean;
  defaultValue: (key: TagEnum) => string[];
}

export const resolveSnTagConfig = (config: SnPartyConfigDTO | undefined, tagValue: (key: TagEnum) => unknown): SnTagConfig => {
  const matches = (cond: TagCondition): boolean => cond.values.includes(String(tagValue(cond.tag)));
  const isVisible = (key: TagEnum): boolean => {
    const t = getTag(config, key);
    return !!t?.visible && (!t.visibleWhen || matches(t.visibleWhen));
  };
  return {
    isVisible,
    isEditable: (key: TagEnum) => getTag(config, key)?.editable ?? false,
    isRequired: (key: TagEnum) => {
      const t = getTag(config, key);
      return isVisible(key) && ((t?.required ?? false) || (!!t?.requiredWhen && matches(t.requiredWhen)));
    },
    defaultValue: (key: TagEnum) => getTag(config, key)?.defaultValue ?? [],
  };
};
